import React, { useEffect, useMemo, useRef } from "react"

import "./zoneMap.scss"
import type { CourtField } from "@/constants/sportConfig"

const BACKGROUND_IMAGE_URL = "/images/verticalGround.svg"

export interface ZoneData {
  zone: number
  count: number
}

export default function ZoneMap({
  data,
  color,
  width,
  height,
  backgroundSvg = BACKGROUND_IMAGE_URL,
  courtField = { left: 0, top: 0, right: 1, bottom: 1 },
}: {
  data: ZoneData[]
  color: string
  width: number
  height: number
  backgroundSvg?: string
  // 이미지 안 실제 경기장 영역(0~1). 기본 full-bleed = 기존(inset:0) 동작.
  courtField?: CourtField
}) {
  // 존 그리드를 경기장 영역에 맞춰 배치 (full-bleed면 inset:0과 동일)
  const gridStyle = {
    left: courtField.left * width + "px",
    top: courtField.top * height + "px",
    width: (courtField.right - courtField.left) * width + "px",
    height: (courtField.bottom - courtField.top) * height + "px",
  }
  const zoneData = useMemo(() => {
    const totalCount = data.reduce((sum, item) => sum + item.count, 0)
    const maxCount = Math.max(...data.map((item) => item.count), 1)

    const zoneMap = new Map<number, { count: number; percentage: number; opacity: number }>()

    for (let i = 1; i <= 18; i++) {
      zoneMap.set(i, { count: 0, percentage: 0, opacity: 0 })
    }

    data.forEach((item) => {
      const percentage = totalCount > 0 ? (item.count / totalCount) * 100 : 0
      const opacity = item.count / maxCount

      zoneMap.set(item.zone, {
        count: item.count,
        percentage: Math.round(percentage * 10) / 10,
        opacity: opacity,
      })
    })

    return zoneMap
  }, [data])

  const renderZone = (zoneNumber: number) => {
    const zone = zoneData.get(zoneNumber)
    if (!zone) {
      return <div className="field-zone" />
    }

    return (
      <div className="field-zone">
        <div
          className="zone-background"
          style={{
            backgroundColor: color,
            opacity: zone.opacity,
          }}
        />
        {<span className="zone-value">{zone.percentage}%</span>}
      </div>
    )
  }

  return (
    <div className="ZoneMap" style={{ width }}>
      <div
        className="ZoneMapContainer"
        style={{
          width: width + "px",
          height: height + "px",
        }}>
        <img className="zone-map-background" src={backgroundSvg} alt="BACKGROUND_IMAGE_URL" />
        <div className="zone-map-grid" style={gridStyle} key={JSON.stringify(data)}>
          {Array.from({ length: 6 }, (_, rowIndex) => (
            <div key={rowIndex} className="zone-map-grid-row">
              {Array.from({ length: 3 }, (_, colIndex) => {
                const zoneNumber = rowIndex * 3 + colIndex + 1

                return renderZone(zoneNumber)
              })}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
